(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["Klarna-calculator"] && !Shopify.designMode) return;
  try {
    (function () {
    function variantId(root) {
      var scope = root.closest('section, product-info, .product, main') || document;
      var input = scope.querySelector('form[action*="/cart/add"] [name="id"]') || document.querySelector('form[action*="/cart/add"] [name="id"]');
      if (input && input.value) return input.value;
      var m = location.search.match(/[?&]variant=(\d+)/);
      return m ? m[1] : null;
    }
    function refresh(root) {
      var data = root.querySelector('[data-kl-variants]');
      var out = root.querySelector('[data-kl-amount]');
      if (!data || !out) return;
      var prices;
      try { prices = JSON.parse(data.textContent); } catch (e) { return; }
      var id = variantId(root);
      if (!id || !(id in prices) || root.dataset.klLast === id) return;
      root.dataset.klLast = id;
      var price = prices[id];
      var count = parseInt(root.dataset.klCount, 10) || 3;
      var min = Math.max(parseInt(root.dataset.klMin, 10) || 0, 3500);
      var max = parseInt(root.dataset.klMax, 10) || 0;
      var fmt = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: root.dataset.klCurrency || 'EUR' });
      out.textContent = fmt.format(Math.floor(price / count) / 100);
      root.hidden = (price <= min) || (max > 0 && price > max);
    }
    function all() { document.querySelectorAll('[data-kl-calc]').forEach(refresh); }
    function init() {
      all();
      if (!window.__klarnaCalcBound) {
        window.__klarnaCalcBound = true;
        document.addEventListener('change', function () { setTimeout(all, 60); });
        setInterval(all, 700);
      }
    }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
    document.addEventListener('shopify:section:load', init);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["collection-random-product"] && !Shopify.designMode) return;
  try {
    (function () {
    function pick(root) {
      if (root.dataset.randomPicked === 'true') return;
      var items = Array.prototype.slice.call(root.querySelectorAll('[data-random-item]'));
      if (items.length === 0) return;
      var index = Math.floor(Math.random() * items.length);
      items.forEach(function (el, i) {
        if (i === index) {
          el.removeAttribute('hidden');
          el.style.display = '';
          el.classList.remove('is-hidden');
        } else {
          el.parentNode.removeChild(el);
        }
      });
      root.dataset.randomPicked = 'true';
    }
    function init() {
      document.querySelectorAll('[data-collection-random-product]').forEach(pick);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();
  } catch(e) { console.error(e); }
})();

})();
